import { PaymentClient, Transaction } from "../../types/transaction";
import { generateAPI } from "../api.generator";

export const verifyTransaction = generateAPI<
  {
    body: {
      transactionReference: string;
      paymentClient: PaymentClient;
    }
  }
, Transaction>("post", "transactions/verify");
